import { useMemo } from 'react'
import './binarytoggle.scss'
export default function BinarySwitch({ options, value, onChange, disabled = false, ariaLabel = 'Toggle', className = '' }) {
  const [left, right] = useMemo(() => {
    if (!Array.isArray(options) || options.length !== 2) {
      return [
        { label: 'Left', value: false },
        { label: 'Right', value: true },
      ]
    }
    return options
  }, [options])
  const isRight = value === right.value
  const wrapperCls = ['seg-toggle', className, disabled ? 'is-disabled' : ''].filter(Boolean).join(' ')
  const onKey = (e) => {
    if (disabled) return
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onChange(isRight ? left.value : right.value)
    }
    if (e.key === 'ArrowLeft') {
      e.preventDefault()
      onChange(left.value)
    }
    if (e.key === 'ArrowRight') {
      e.preventDefault()
      onChange(right.value)
    }
  }
  return (
    <div className={wrapperCls} role="group" aria-label={ariaLabel} onKeyDown={onKey}>
      <button
        type="button"
        className={`seg-btn ${value === left.value ? 'is-active' : ''}`}
        onClick={() => !disabled && onChange(left.value)}
        disabled={disabled}
      >
        {left.label}
      </button>
      <button
        type="button"
        className={`seg-btn ${value === right.value ? 'is-active' : ''}`}
        onClick={() => !disabled && onChange(right.value)}
        disabled={disabled}
      >
        {right.label}
      </button>
    </div>
  )
}
